import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartItemComponentStore } from 'cart-data';
import { IfHasRenderInSourcesDirective, RenderInService } from 'common-ui';
import { ProductDetailsComponentStore } from 'products-data';
import { CART_ITEM_RESULT_VIEW_COMPONENT_TOKENS } from '../../../types';
import { CartItemHostComponentBase } from '../CartItemHostComponentBase';
import { CartItemResultRenderTarget, CartItemResultRenderTargetComponents } from './render-targets';
import { RenderTargetComponents } from './render-targets/RenderTargetComponents';

@Component({
  selector: 'ideal-cart-item-result-layout',
  imports: [RouterModule, NgComponentOutlet, RenderTargetComponents, IfHasRenderInSourcesDirective],
  standalone: true,
  templateUrl: './cart-item-result-layout.component.html',
  styleUrl: './cart-item-result-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RenderInService, ProductDetailsComponentStore, CartItemComponentStore],
  host: {
    '(mouseenter)': 'hovered.set(true)',
    '(mouseleave)': 'hovered.set(false)',
    '[class.hovered]': 'hovered()',
  },
})
export class CartItemResultLayoutComponent extends CartItemHostComponentBase {
  private readonly _store = inject(CartItemComponentStore);

  protected readonly LayoutTargets = CartItemResultRenderTarget;
  protected readonly LayoutComponents = CartItemResultRenderTargetComponents;

  protected readonly isLoading = computed(() => this._store.cartItemLoading());
  protected readonly isPriceOnRequest = computed(() => this._store.cartItemPricing().pricingModel.isCallForPricing);
  protected readonly quantity = computed(() => this._store.cartItemQuantity());
  protected readonly isUpdating = computed(() => this._store.cartItemUpdating());
  protected readonly hovered = signal(false);
  protected readonly drawerFocused = signal(false);
  protected readonly drawerOpen = computed(() => this.hovered() || this.drawerFocused());

  protected readonly componentInputs = computed(() => ({
    itemId: this.itemId(),
  }));

  constructor() {
    super(CART_ITEM_RESULT_VIEW_COMPONENT_TOKENS);
    effect(() => {
      this._store.selectByItemId(this.itemId());
    });
  }
}
